<template>
    <Dialog v-model:visible="isVisible" header="Export Company" @hide="hide()" @show="show()" :dismissable="false"
        :draggable="false" :modal="true" :style="{ width: '30vw' }">
        <!-- <span v-show="errMessage" class="p-error">{{ errMessage }}</span> -->

        <div class="mt-3">
             <div class="p-inputtext-sm p-fluid">
               <FormField
                fieldName="Type"
                :labelName="$t('type')"
                v-model="FilterCompany"
                fieldClass="col-6"
                labelClass="col-2"
              >
                <CustomSelect
                  v-model="FilterCompany.Type"
                  class="p-inputtext-sm"
                  :url="this.$API_URL + 'list/country_code'"
                  :minLength="0"
                  :params="{}"
                  :filter="true"
                />
                 <small
                        v-if="
                          submitted && !FilterCompany.Type
                        "
                        class="p-error"
                        >{{ $t("is_required").replace("Value", $t("type")) }}
                      </small>
              </FormField>
             </div>
           
        </div>


        <template #footer>
            <Button type="button" icon="pi pi-save" class="p-button p-button-success" @click="getReport()" label="Export"  :disabled="disableButton" />    
        </template>
    </Dialog>

    <ShowReport
      :title="title"
      :isVisible="showReport"
      :reportTbl="this.reportTbl"
      @close="resetBtn()"
    />
</template>
<script>
import ShowReport from "../Report/ShowReport.vue";
import FormField from "../Base/Helper/FormField.vue";
import moment from 'moment';
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
    components: {
      ShowReport,
      FormField,
    },
    data() {
        return {
            v$: useVuelidate(),
            errMessage: null,
            monthYear: null,
            reportTbl: null,
            disableButton: false,
            monthYearString: null,
            url: this.$API_URL + "company/export",
            companyId : this.$store.getters.getCompanyId,
            modelPassword: null,
            username : this.$store.getters.getUsername,
            coyCodeUser : this.$store.getters.getCompanyCode,
            userTimeZoneOffset: moment().utcOffset() / 60,
            timezoneUserOffset: this.$store.getters.getTimezoneOffset,
            userTime: moment().format("HH:mm"),
            coyCodeSupply : null,
             submitted: false,
            FilterCompany: {
                Type: null,
            },
             changeCompany: {
                coy: null
            },
        };
    },
    validations() {
        return {
            changeCompany: {
                coy: { required }
            },
        };
    },
    props: {
        model: {
            type: Object,
            default: null,
        },
        userId: {
            type: String,
            default: null,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        requireCompany: {
            type: Boolean,
            default: false
        },
        initialErrorMessage: {
            type: String,
            default: ""
        },
        changeFirstLogin: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        show() {
            if (this.initialErrorMessage) {
                this.errMessage = this.initialErrorMessage;
            }
        },
        hide() {
         
            this.v$.$reset();
            this.$emit("update:isVisible", false);
            this.$emit("hide");
        },
        resetBtn() {
            this.reportTbl = null;
            this.monthYear = null;
            this.FilterCompany.Type = null;
            this.showReport = false;
            this.$emit("update:isVisible", false);
            this.$emit("hide");
        },
        passwordClass(data) {
            if (data.showPassword == undefined) {
                data.showPassword = "pi pi-eye";
            }
            data.showPassword =
                data.showPassword == "pi pi-eye-slash" ||
                    data.showPassword == undefined
                    ? "pi pi-eye"
                    : "pi pi-eye-slash";
            return data.showPassword;
        },
        passwordType(data) {
            return data == "pi pi-eye" ? "pi pi-eye-slash" : "pi pi-eye";
        },
        reopenTab() {
            this.showReport = true;
        },
        changeCoy(e) {
            //console.log(e)
            this.coyCodeSupply = e == null ? null : e.code;
        },
        onChangeMonthYear(e) {
            const year = this.monthYear.getFullYear();
            const month = String(this.monthYear.getMonth() + 1).padStart(2, "0");
            this.monthYearString = `${year}-${month}`;
            this.FilterCompany.monthYear = this.monthYearString;
        },
        getReport() {
            this.disableButton = true;
            this.submitted = true;
             if (
                    !this.FilterCompany.Type
            ) {
                 this.disableButton = false;
                return false;
            }

        // this.visibleBar = true;
        // this.loadingReport = !this.loadingReport;
        this.$emit("block-ui");
        this.$axios
          .post(this.url, this.FilterCompany)
          .then((response) => {
            if(response.data.success){
                this.reportTbl = {
                                header: response.data.data.header,
                                content: response.data.data.content,
                                title: response.data.data.title,
                                };
                // this.showError(response);
                this.showReport = true;
            }else{
                this.showError(response);
            }
           this.disableButton = false;
            this.$emit("unblock-ui");
          })
          .catch((exc) => {
            // this.showError(response);
            // //console.log(1);
            this.disableButton = false;
           this.$emit("unblock-ui");
          });
      },
    },
    emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
